define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'service/AttributesManager',
	'canvas/InformationCanvas',
	'amdi18n-loader?!identity/nls/IdentityAttributesView_strings',
	'lib/jquery'
], function (
		Util,
		UiUtil,
		AttributesManager,
		InformationCanvas,
		Strings,
		jQuery
		) {
	'use strict';

	/**
	 * IdentityAttributesView class
	 */
	return function (attributesManager, attributeValueCallbacks) {
		var _attributeValueCallbacks = attributeValueCallbacks,
				_attributesManager,
				_moreShown = false,
				_view = jQuery(
						"<div id='skIdS_identity-attributes-container'>" +
						'<div id="skIdS_identity-decrypt-input-error"></div>' +
						"<p class='skIdS_identity-table-heading'>" + Strings.content_cloudid_text + "</p>" +
						"<div id='skIdS_identity-attributes-table' class='skIdS_identity-listing-table'></div>" +
						"<p class='skIdS_identity-table-heading'>" + Strings.information_cloudid_text + "</p>" +
						"<div id='skIdS_identity-information-table' class='skIdS_identity-listing-table'></div>" +
						"</div>");

		if (attributesManager instanceof AttributesManager) {
			_attributesManager = attributesManager;
		} else {
			throw new Error('invalid attributesManager');
		}


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (identity, authenticationOption, attributes, state, error) {
			var name,
					value,
					attributesTable,
					infoTable,
					errorElement,
					i,
					eIdentifierPresent = false,
					mainOrigin = null;

			attributesTable = _view.find('#skIdS_identity-attributes-table');
			infoTable = _view.find('#skIdS_identity-information-table');
			errorElement = _view.find('#skIdS_identity-decrypt-input-error');

			attributesTable.empty();
			infoTable.empty();
			errorElement.empty();

			if (error) {
				errorElement.append(error.data()).show();
			} else {
				errorElement.hide();
			}

			if (Util.isArray(attributes) && attributes.length > 0) {
				attributes = _attributesManager.sortAttributes(attributes);

				for (i = 0; i < attributes.length; i++) {
					name = _attributesManager.name(attributes[i].name(), true);

					if (Util.endsWith(attributes[i].name(), 'eIdentifier')) {
						if (mainOrigin === null) {
							// use the origin of the first encountered eIdentifier as the main origin of the CloudID
							mainOrigin = attributes[i].origin();
						}
						if (!eIdentifierPresent) {
							eIdentifierPresent = true;
							attributesTable.append(
									"<div>" +
									"<div>" + name + "</div>" +
									"<div><i>" + Strings.service_provider_specific_identifier + "</i></div>" +
									"</div>");
						}
					} else if (attributes[i].value() !== null) {
						var info = "<div>" +
								"<div>" + name + "</div>" +
								"<div><div>" + attributes[i].value() + "</div>";
						var nextName = i < attributes.length - 1 ? _attributesManager.name(attributes[i + 1].name(), true) : null;
						while (nextName === name) {
							info += "<div><div>" + attributes[++i].value() + "</div>";
							nextName = i < attributes.length - 1 ? _attributesManager.name(attributes[i + 1].name(), true) : null;
						}
						attributesTable.append(info + "</div></div>");
					} else {
						attributesTable.append(
								"<div>" +
								"<div>" + name + "</div>" +
								"<div class='skIdS_identity-listing-red'>" + Strings.not_available + "</div>" +
								"</div>");
					}
				}
			} else {
				var attributeIdentifiers = _attributesManager.sortAttributes(identity.attributeIdentifiers());

				if (!identity.isValid()) {
					value = Strings.value_expired;
				} else {
					switch (state) {
						case 'revoked':
							value = Strings.value_revoked;
							break;
						case 'expired':
							value = Strings.value_expired;
							break;
						default:
							value = Strings.value_protected;
					}
				}

				for (i = 0; i < attributeIdentifiers.length; i++) {
					name = _attributesManager.name(attributeIdentifiers[i], true);

					if (typeof _attributeValueCallbacks !== 'undefined') {
						attributesTable.append(
								"<div>" +
								"<div>" + name + "</div>" +
								"<div><a href='javascript:;'>" + value + "</a></div>" +
								"</div>");

						attributesTable.find('a').last().on('click', function (event) {
							event.preventDefault();

							Util.callCallbacks(_attributeValueCallbacks);
						});
					} else {
						attributesTable.append(
								"<div>" +
								"<div>" + name + "</div>" +
								"<div>" + value + "</div>" +
								"</div>");
					}
				}
			}

			// show valid until
			if (identity.isValid()) {
				infoTable.append(
						"<div>" +
						"<div>" + Strings.valid_until + "</div>" +
						"<div>" + Util.toDateString(identity.validUntil()) + "</div>" +
						"</div>");
			} else {
				infoTable.append(
						"<div>" +
						"<div>" + Strings.valid_until + "</div>" +
						"<div class='skIdS_identity-listing-red'>" + Util.toDateString(identity.validUntil()) + "</div>" +
						"</div>");
			}

			// show origin description (if present)
			if (authenticationOption) {
				infoTable.append(
						"<div>" +
						"<div>" + Strings.source_identity + "</div>" +
						"<div>" + authenticationOption.description() + "</div>" +
						"</div>");
			}

			// show more button
			infoTable.append(
					"<div class='skIdS_identity-listing-toggle'>" +
					"<div>" + Strings.more_text + "</div>" +
					"</div>");

			// show valid from
			infoTable.append(
					"<div class='skIdS_identity-listing-row-hidden'>" +
					"<div>" + Strings.valid_from + "</div>" +
					"<div>" + Util.toDateString(identity.validFrom()) + "</div>" +
					"</div>");

			// show origin issuer (if present)
			if (mainOrigin !== null && mainOrigin.issuer().length > 0) {
				infoTable.append(
					"<div class='skIdS_identity-listing-row-hidden'>" +
						"<div>" + Strings.origin_issuer + "</div>" +
						"<div>" + mainOrigin.issuer()[0] + "</div>" +
					"</div>");
			}
			
			// show bindings
			for (var b in identity.bindingProtocol()) {
				infoTable.append(
						"<div class='skIdS_identity-listing-row-hidden'>" +
						"<div>" + Strings.binding + "</div>" +
						"<div>" + identity.bindingProtocol()[b].type() + "</div>" +
						"</div>");
				
				if(identity.bindingProtocol()[b].type() === "http://ws.skidentity.de/ci/binding/key/v1.0") {
					infoTable.append(
						"<div class='skIdS_identity-listing-row-hidden'>" +
						"<div>" + Strings.origin + "</div>" +
						"<div>" + identity.bindingProtocol()[b].origin() + "</div>" +
						"</div>");
				}
			}

			_view.find('.skIdS_identity-listing-table > div')
					.mouseover(function () {
						jQuery(this).children('div').css('white-space', 'normal');
					})
					.mouseout(function () {
						jQuery(this).children('div').css('white-space', 'nowrap');
					});

			_view.find('.skIdS_identity-listing-toggle').click(function () {
				var rows = _view.find('.skIdS_identity-listing-row-hidden:not(:last-child)'),
						lastRow = _view.find('.skIdS_identity-listing-row-hidden:last-child')

				if (_moreShown) {
					rows.slideUp('fast');
					lastRow.slideUp('fast')
				} else {
					rows.slideDown('fast');
					lastRow.slideDown('fast', function () {
						UiUtil.scrollTo(jQuery(this));
					});
				}

				_view.find('.skIdS_identity-listing-toggle > div').text(_moreShown ? Strings.more_text : Strings.less_text);

				_moreShown = !_moreShown;
			});

			_view.find('.skIdS_identity-listing-row-hidden').hide();
		};
	};
});



//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/identity/IdentityAttributesView.js
// module id = 333
// module chunks = 1